export default "__VITE_ASSET__e0b0a4ea__"